// extracted by mini-css-extract-plugin
export default {"root":"ManualUploadButton_root__BYYc-"};